import { useState } from "react";
import style from "./style.module.scss";
import TableResponsive from "../TableResponsive";
import useFormat from "../../hooks/utils/useFormat";
import StatusFlag from "../../components/StatusFlag";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import { ModalConfirm, ModalUpload } from "../Modal";
import { toast } from "react-toastify";
import Button from "../Button";
import Loading from "../Loading";

export default function FileDisplay(props) {
  const { files, reload, commercial_id, loading } = props;
  const { formatDate } = useFormat();
  const { me, config, token } = useWrapper();

  const [downloadInfos, setDownloadInfos] = useState({ modalOpen: false });
  const downloadFile = async (url, fileName) => {
    const _pre_url = me?.type === "Formando" ? "trainee/" : "";
    const { data: _file } = await api.get(_pre_url + url, config);
    setDownloadInfos({
      id: _file.id,
      fileName: fileName,
      url: _file.download,
      modalOpen: true,
      publico: _file.publico,
    });
  };

  const [modalUploadText, setModalUploadText] = useState({
    title: null,
    text: null,
  });
  const [filePermission, setfilePermission] = useState();
  const [loadingUpload, setloadingUpload] = useState();
  const uploadFile = async file => {
    setloadingUpload(true);
    try {
      let bodyFormData = new FormData();
      bodyFormData.append("file", file);
      const _is_trainee = me?.type === "Formando";
      const _url_prefix = _is_trainee ? "trainee/" : "";
      const { data: _file } = await api.post(`${_url_prefix}files`, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          contract: 0,
          commercial: commercial_id,
          publico: filePermission,
        },
      });
      if (!!commercial_id) {
        const { data: _commercial } = await api.put(
          `${_url_prefix}commercial/${commercial_id}`,
          {
            files: [_file.id],
          },
          config,
        );

        if (!_is_trainee) {
          await api.post(
            "activity",
            {
              message: `Upload do arquivo <b>${_file?.name}</b> efetuado`,
              user_id: me.id,
              commercial_id: commercial_id,
              type: "act",
            },
            config,
          );
        }
      }
      toast.success(modalUploadText.contract ? "Turma criada com sucesso!" : "Anexo feito com sucesso!");
      setModalUploadText({ title: null, text: null });
      reload();
    } catch (__err) {
      console.log("__err", __err);
      toast.error("Erro ao tentar subir o arquivo.");
    }
    setloadingUpload(false);
  };

  return (
    <>
      {!loading ? (
        <>
          <div className="d-flex justify-content-end mb-3">
            {(me?.type === "Gestor" || !!me?.is_member) && (
              <Button
                color="primary"
                size="sm"
                onClick={() => {
                  setModalUploadText({
                    title: "Anexar Arquivo",
                    text: "",
                  });
                }}
              >
                Novo Arquivo
              </Button>
            )}
          </div>
          <TableResponsive
            emptyMsg="Nenhum arquivo encontrado."
            table={{
              head: [{ data: "Id" }, { data: "Nome" }, { data: "Data" }, { data: "" }],
              body:
                files?.map(__file => ({
                  onClick: () => {
                    downloadFile(`files/${__file.id}/download`, __file.name);
                  },
                  data: [
                    { element: __file.id },
                    { element: __file.name },
                    { element: formatDate(__file.created_at, 1) },
                    {
                      element: (
                        <div className="text-end">
                          <StatusFlag
                            status={
                              !!__file?.contract
                                ? "Contrato"
                                : __file?.publico === "publico"
                                ? "Público"
                                : __file?.publico === "comissao"
                                ? "Comissão"
                                : __file?.publico === "empresa"
                                ? "Gestores"
                                : "Legado"
                            }
                          />
                        </div>
                      ),
                    },
                  ],
                })) || [],
            }}
          />
          <ModalConfirm
            show={downloadInfos.modalOpen}
            title={downloadInfos.fileName}
            text={`Deseja efetuar o download do arquivo ${downloadInfos.fileName}?`}
            select={{
              ...(me?.type === "Gestor"
                ? {
                    value: downloadInfos.publico,
                    setvalue: __value => {
                      setDownloadInfos({
                        ...downloadInfos,
                        publico: __value,
                      });
                      api
                        .put(
                          `files/${downloadInfos.id}`,
                          {
                            publico: __value,
                          },
                          config,
                        )
                        .then(() => {
                          setDownloadInfos({ modalOpen: false });
                          toast.success("Arquivo editado com sucesso!");
                          reload();
                        });
                    },
                    options: [
                      { label: "Arquivo Público", value: "publico" },
                      { label: "Apenas Gestores", value: "empresa" },
                      { label: "Apenas Comissão", value: "comissao" },
                    ],
                  }
                : {}),
            }}
            options={[
              ...(me?.type === "Gestor"
                ? [
                    {
                      label: "Deletar",
                      buttonColor: "error",
                      effect: () => {
                        api
                          .put(
                            `files/${downloadInfos.id}`,
                            {
                              active: 0,
                            },
                            config,
                          )
                          .then(() => {
                            setDownloadInfos({ modalOpen: false });
                            toast.success("Arquivo deletado com sucesso!");
                            reload();
                          });
                      },
                    },
                  ]
                : []),
              {
                label: "Download",
                buttonColor: "primary",
                effect: () => {
                  window.open(downloadInfos.url);
                  setDownloadInfos({ modalOpen: false });
                },
              },
            ]}
            closeModal={() => {
              setDownloadInfos({ modalOpen: false });
            }}
            colorScheme="secondary"
          />
          <ModalUpload
            reload={reload}
            show={!!modalUploadText.title}
            closeModal={() => setModalUploadText({ title: null, text: null })}
            title={modalUploadText.title}
            pretext={modalUploadText.text}
            uploadCB={uploadFile}
            loading={loadingUpload || loading}
            commercial_file={true}
            filePermission={filePermission}
            setfilePermission={setfilePermission}
          />
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}
